const stream = [
  {
    tag: "早年言论",
    who: "过气顶流 · 阿亮",
    line: "「我不认识那家站，也从没参加过」，和早年间被拍到的入场照对上了号。",
    meta: "归档 0321 · 09:40",
  },
  {
    tag: "黑历史后续",
    who: "转型爱豆 · 小柯",
    line: "旧访谈里那句「为钱什么都演」被重新翻出，后台的回应至今只有一句「不记得了」。",
    meta: "归档 0318 · 昨日",
  },
  {
    tag: "陈年往事",
    who: "选秀评委 · 吴老师",
    line: "五年前当众放话「绝不和此人同台」，最近同场海报却把两人并排挂了上去。",
    meta: "归档 0316 · 昨日",
  },
  {
    tag: "考古发现",
    who: "唱跳旧友 · 老周",
    line: "一段被删过的电台录音被找回，补上了「和解又翻脸」中间缺掉的半年。",
    meta: "归档 0309 · 3 天前",
  },
  {
    tag: "早年言论",
    who: "童星出身 · 麦麦",
    line: "十岁时那句「我比他们都红」，被粉丝考古出了完整采访出处与现场花絮。",
    meta: "归档 0305 · 4 天前",
  },
  {
    tag: "陈年往事",
    who: "主持人 · 阿发",
    line: "当年台上那句玩笑救场话，如今被逐字拆开，成了这段旧账的最后一环。",
    meta: "归档 0301 · 5 天前",
  },
];

export default function FlashStream() {
  return (
    <section id="today" className="scroll-mt-4 bg-[#faf5eb]">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <h4 className="flex items-center gap-2 text-[11px] tracking-[0.35em] text-[#b1401f]">
              <i className="ri-fire-line" aria-hidden="true"></i>
              今日新账 · 快讯流
            </h4>
            <h3 className="font-display mt-3 text-2xl font-black text-[#1a160e] md:text-4xl">
              老料新账，刚入档的几笔
            </h3>
          </div>
          <p className="text-sm text-[#6f6552]">条目陆续补录 · 只放能对上号的，不贴捕风捉影。</p>
        </div>

        <div className="mt-10 grid gap-x-10 gap-y-0 lg:grid-cols-2">
          {stream.map((it, i) => (
            <a
              key={it.meta}
              href="#dossier"
              className="group flex flex-col gap-2 border-b border-[#e3d7bd] py-5 md:py-6"
            >
              <div className="flex items-center gap-3">
                <span className="text-[10px] font-medium tracking-widest text-[#6f6552]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="border border-[#e3d7bd] px-1.5 py-0.5 text-[10px] tracking-widest text-[#b1401f]">
                  {it.tag}
                </span>
                <span className="text-[10px] text-[#978a72]">{it.meta}</span>
              </div>
              <h3 className="font-display text-base leading-relaxed font-bold text-[#1a160e] transition group-hover:text-[#b1401f] md:text-lg">
                <span className="text-[#978a72]">{it.who}：</span>
                {it.line}
              </h3>
              <span className="mt-1 hidden items-center gap-1 text-[11px] text-[#978a72] opacity-0 transition group-hover:opacity-100 sm:flex">
                点开展开这一笔的来龙去脉
                <i className="ri-arrow-right-line text-xs" aria-hidden="true"></i>
              </span>
            </a>
          ))}
        </div>

        <div className="mt-8 flex justify-center">
          <button
            type="button"
            className="flex cursor-pointer items-center gap-2 border border-[#1a160e] px-6 py-3 text-sm font-medium whitespace-nowrap transition hover:bg-[#1a160e] hover:text-[#faf5eb]"
          >
            <i className="ri-add-line text-base" aria-hidden="true"></i>
            再翻往前 10 笔
          </button>
        </div>
      </div>
    </section>
  );
}